import { Checkbox, TableBody, TableCell } from '@mui/material'
import React from 'react'
import { DatagridBodyProps, RaRecord, useListContext } from 'react-admin'
import ExpandableDatagridRow from './ExpandableDatagridRow'

interface ExpandableDatagridBodyProps extends DatagridBodyProps {
    builderConfig?: any
}

const ExpandableDatagridBody: React.FC<ExpandableDatagridBodyProps> = ({
    builderConfig,
    ...props
}) => {
    const { selectedIds, onToggleItem } = useListContext()

    return (
        <TableBody>
            {props.data?.map((record: RaRecord, rowIndex: number) =>
                props.children ? (
                    <ExpandableDatagridRow
                        key={record.id || rowIndex}
                        record={record}
                        builderConfig={builderConfig}
                    >
                        <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                            <Checkbox
                                checked={selectedIds.includes(record.id)}
                                onChange={() => onToggleItem(record.id)}
                                color="primary"
                            />
                        </TableCell>
                        {React.Children.map(props.children, (child, index) => {
                            if (index === 0) return null
                            return (
                                <TableCell key={`${record.id || rowIndex}-${index}`}>
                                    {React.cloneElement(child as React.ReactElement<any>, {
                                        record
                                    })}
                                </TableCell>
                            )
                        })}
                    </ExpandableDatagridRow>
                ) : null
            )}
        </TableBody>
    )
}

export default ExpandableDatagridBody
